import '../../../plugins/custom-form/js/jcf';
import '../../../plugins/custom-form/js/jcf.select';

(function () {
    const $body = $('body'),
        looker = {
            $lookerWrapper: $('.looker'),
            reportFilter: '.looker__filters--report',
            $reportFilter: $('.looker__filters--report'),
            filter: '.looker__filters__field',
            $filter: $('.looker__filters__field'),
            $boxes: $('.looker .box'),
            url: '/action/looker?target=embed/dashboards-next/',
            $activeIframe: null,
            maxFilterOptionSelection: null,
            lastValidSelection: null,
            jcfSelectFilterInstance: null,

            init() {
                this.selectReport();
                this.control();
                this.initSubmitButtons();
                this.additionalSticky();
            },
            control() {
                this.$lookerWrapper.on('change', this.reportFilter, e => {
                    this.selectReport();
                });

                $body.on('click', '.looker__filters__submit', e => {
                    let iframeSrc = looker.url + this.$reportFilter.val(),
                        iframeSrcWithParam = this.collectParams(iframeSrc);

                    this.$filter.each(function (item) {
                        let $this = $(this);
                        window.jcf.getInstance($this).instance.hideDropdown();
                    });

                    this.$lookerWrapper.addClass('is--loading');
                    this.$activeIframe.attr('src', iframeSrcWithParam);
                    this.$activeIframe.load(e => {
                        this.$lookerWrapper.removeClass('is--loading');
                    });
                });

                $body.on('click', '.looker__filters__cancel', e => {
                    let $this = $(e.target),
                        jcfArray = [],
                        iframeSrc = this.$activeIframe.attr('src'),
                        $wrapper = $this.closest('.looker__filters-wrapper'),
                        $jcfSelector = $wrapper.find('.jcf-select-looker__filters__field'),
                        $Selector = $wrapper.find('.looker__filters__field'),
                        paramName = $Selector.attr('name'),
                        selectedFilters = UX.pageBody.urlParam.getParamVal(iframeSrc, paramName),
                        selectedFiltersArray = null,
                        selectedFiltersArrayDecoded = [];

                    if (selectedFilters === 'undefined' || selectedFilters === '') {
                        selectedFilters = 'Select Institution';
                    }

                    selectedFiltersArray = selectedFilters.split(', ');
                    let textVal = selectedFiltersArray.toString().replace(/,/g, ', ');

                    $jcfSelector.find('.jcf-select-text span').html(decodeURIComponent(`${textVal}`));

                    // in case item has comma ex 'Friends of the Earth, Australia'
                    $.each(selectedFiltersArray, function (index, value) {
                        selectedFiltersArrayDecoded.push(decodeURIComponent(value));
                    });

                    $Selector.val(selectedFiltersArrayDecoded);
                    $jcfSelector.find('.jcf-selected').each(function () {
                        jcfArray.push($(this).text());
                        let difference = jcfArray.filter(x => !selectedFilters.includes(x));

                        if (difference.length) {
                            $(this).removeClass('jcf-selected');
                        }
                    });

                    window.jcf.getInstance($Selector).instance.hideDropdown();
                });

                this.$lookerWrapper.on('change', this.filter, e => {
                    let $this = $(e.target),
                        jcfArray = [],
                        $wrapper = $this.closest('.looker__filters-wrapper'),
                        $jcfSelector = $wrapper.find('.jcf-select-looker__filters__field'),
                        filters = $this.val(),
                        maxOptionSelection = $this.data('max-options');

                    if (filters.length > maxOptionSelection) {
                        let textVal = this.lastValidSelection.toString().replace(/,/g, ', ');
                        $jcfSelector.find('.jcf-select-text span').html(`${textVal}`);
                        $this.val(this.lastValidSelection);

                        $jcfSelector.find('.jcf-selected').each(function () {
                            jcfArray.push($(this).text());
                            let difference = jcfArray.filter(x => !looker.lastValidSelection.includes(x));
                            if (difference.length) {
                                $(this).removeClass('jcf-selected');
                                return false;
                            }
                        });

                        if (!$wrapper.find('.alert-msg--warning').length) {
                            $wrapper
                                .find('.looker__filters__footer')
                                .prepend(
                                    `<p class="alert-msg--warning"><i class="icon-warning-triangle"></i>Selection limit reached ( ${maxOptionSelection}  items max)</p>`
                                );
                        }

                        setTimeout(function () {
                            $wrapper.find('.alert-msg--warning').remove();
                        }, 3000);
                    } else {
                        this.lastValidSelection = $this.val();
                    }
                });
            },
            selectReport() {
                let reportId = this.$reportFilter.val(),
                    iframeUrl = this.url + reportId,
                    iframeBox = this.$reportFilter.find('option:selected').data('box'),
                    $iframeBox = $('.' + iframeBox),
                    activeUrl = null;

                if ($iframeBox.length) {
                    activeUrl = $iframeBox.find('iframe').attr('src');
                    iframeUrl = this.collectParams(iframeUrl);

                    this.$activeIframe = $iframeBox.find('iframe');

                    if (activeUrl !== iframeUrl) {
                        this.$lookerWrapper.addClass('is--loading');
                        this.$activeIframe.attr('src', iframeUrl);
                        this.$activeIframe.load(e => {
                            this.$lookerWrapper.removeClass('is--loading');
                        });
                    }
                }

                this.$boxes.hide().removeClass('active');
                $iframeBox.show().addClass('active');
            },
            initSubmitButtons() {
                if ($('.looker__filters-wrapper').length) {
                    let $wrapper = $('.looker__filters-wrapper'),
                        wrapperWidth = $wrapper.outerWidth();
                    $wrapper
                        .find('.jcf-select-looker__filters__field')
                        .append(
                            `<div class="looker__filters__footer"><button class="btn transparent looker__filters__cancel">Cancel</button><button class="btn blue looker__filters__submit">Submit</button></div>`
                        );
                    $wrapper.find('.jcf-select-text').css('width', wrapperWidth - 40);
                }
            },
            collectParams(activeUrl) {
                let filters = '';
                this.$filter.each(function (item) {
                    let $this = $(this);
                    if ($this.val().length) {
                        filters = $this
                            .val()
                            .map(i => encodeURIComponent(i))
                            .join('&' + $this.attr('name') + '=');
                        activeUrl = UX.pageBody.urlParam.replace(activeUrl, $this.attr('name'), filters);
                    }
                });
                return activeUrl;
            },
            additionalSticky() {},
        };
    UX.looker = looker;
})();
